import axios from 'axios';
import API_HOST from '../api';

const accessLogApi = function() {
  const api = {};

  api.getLoginAttempts = function(page, limit, username, startTime, endTime, appTypeId, appVersion) {
    let url = `${API_HOST}/api/log/login`;

    const queryParams = [];
    if (username !== undefined && username !== '') queryParams.push(`username=${username}`);

    if (appVersion !== undefined && appVersion !== null) { queryParams.push(`appVersion=${appVersion}`); }

    if (appTypeId !== undefined && Number(appTypeId) !== -1) queryParams.push(`appTypeId=${appTypeId}`);

    if (startTime !== undefined && startTime !== null) queryParams.push(`startTime=${moment(startTime).utc().format('X')}`);

    if (endTime !== undefined && endTime !== null) queryParams.push(`endTime=${moment(endTime).utc().format('X')}`);

    if (page !== undefined) queryParams.push(`page=${page}`);

    if (limit !== undefined) queryParams.push(`limit=${limit}`);

    if (queryParams.length > 0) url = `${url}?${queryParams.join('&')}`;

    return axios({
      url,
      method: 'GET',
    });
  };

  api.getAppTypes = function() {
    const url = `${API_HOST}/api/app-type-list`;

    return axios({
      url,
      method: 'GET',
    });
  };

  return api;
};

export default accessLogApi();
